/**
 * Created by Ning Jiang on 2/7/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {StepCountUpBigWinController} from "@nolimitcity/slot-game/bin/game/winpresentation/bigwin/stepcountup/StepCountUpBigWinController";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {TombstoneGameMode} from "../../gamemode/TombstoneGameMode";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneGameConfig} from "../../TombstoneGameConfig";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";
import {WinWaysIndicator} from "../winways/WinWaysIndicator";
import {TombstoneBigWinCountUp} from "./TombstoneBigWinCountUp";
import {TombstoneBigWinView} from "./TombstoneBigWinView";
import {TombstoneGameModuleConfig} from "../../TombstoneGameModuleConfig";

export class TombstoneBigWinController extends StepCountUpBigWinController {

    private _gameView:TombstoneBigWinView;
    private _winCountUp:TombstoneBigWinCountUp;
    private _tombstoneData:TombstoneParsedGameData;
    private _lastSpinBeforeOutro:boolean;

    constructor(indexes:[number, number]) {
        super(indexes, {skipLastLevelCountUpIfSmall : true});

        this._gameView = new TombstoneBigWinView();
        this._winCountUp = new TombstoneBigWinCountUp();
        this._winCountUp.position.set(GameConfig.instance.GAME_WIDTH * 0.5, GameConfig.instance.GAME_HEIGHT * 0.60);


        StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.WIN_COUNT_UP_ABOVE.name).addChild(this._winCountUp);
    }

    protected parseFeatureGameData(data:TombstoneParsedGameData):void {
        super.parseFeatureGameData(data);
        this._tombstoneData = data;
        const lastRespin:boolean = data.mode === GameMode.RESPIN && data.nextMode === GameMode.NORMAL;
        const lastFreespin:boolean = data.freespinsLeft === 0 && (data.mode === TombstoneGameMode.SUPER_FREESPIN || data.mode === GameMode.FREESPIN);
        this._lastSpinBeforeOutro = lastRespin || lastFreespin;
    }

    protected startWinPresentation():void {
        super.startWinPresentation();
        this._winCountUp.alpha = 1;

        EventHandler.dispatchEvent(new GameEvent(WinWaysIndicator.SHOW_WIN_WAYS_WON));

        if(this._tombstoneData.brokeTheBank) {
            SlotGame.sound.fadeAmbience(0, 10);
        }
    }

    protected playBigWinSound():void {
        SlotGame.sound.playEffect(TombstoneSoundConfig.instance.BIG_WIN);
    }

    protected stopAllSounds():void {
        SlotGame.sound.stopEffect(TombstoneSoundConfig.instance.BIG_WIN);
        SlotGame.sound.playEffect((<any>TombstoneSoundConfig.instance)[`BIG_WIN_ENDS_${this._winLevel}`]);
        if(TombstoneGameModuleConfig.gameData.brokeTheBank && this._winLevel === 2) {
            SlotGame.sound.playEffect(TombstoneSoundConfig.instance.CAP_WIN_INTRO);
            //debugger;
            new TimelineLite().add(() => {
                //debugger;
                SlotGame.sound.playEffect(TombstoneSoundConfig.instance.CAP_WIN_LOOP, 1000);

            }, 4);
        }

        if(!this._lastSpinBeforeOutro && !this._tombstoneData.brokeTheBank) {
            //debugger;
            SlotGame.sound.fadeAmbience(1, 1000);
        }
    }

    protected getBigWinLevelAnimation(level:number):Timeline {
        return this._gameView.getBigWinLevelAnimation(this._winRatios[level], level);
    }

    protected playCountUp(from:number, to:number, duration:number, preTotalWin:number = 0):Timeline | null {
        return this._winCountUp.getCountUpAnimation(from, to, duration);
    }

    protected playEndingAnimation(isAborted:boolean):void {
        if(this._winLevel > -1) {
            this._gameView.playEndingAnimation(this._winLevel);

            if(TombstoneGameModuleConfig.gameData.isWinBelowStake() && TombstoneGameModuleConfig.gameData.mode !== GameMode.NORMAL) {
                SlotGame.keypad.setWin(this._tombstoneData!.accumulatedRoundWin, true, TombstoneGameModuleConfig.gameData.isWinBelowStake());
            } else {
                SlotGame.winFieldController.showWinField();
            }

            this._winCountUp.abort((!this._tombstoneData.brokeTheBank || TombstoneGameModuleConfig.gameData.mode === GameMode.NORMAL)? this._tombstoneData!.singleWin : this._tombstoneData!.accumulatedRoundWin, isAborted);
        }
    }

    public playEndForWinCap():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add(() => {
            this._winCountUp.abort(this._tombstoneData!.accumulatedRoundWin, true);
        });

        return  tl;
    }

    public  fadeOutForWinCap():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add(TweenLite.to(this._winCountUp, 0.2, {alpha: 0}));
        tl.add(() => {
            SlotGame.keypad.setWin(this._tombstoneData!.accumulatedRoundWin);
            SlotGame.keypad.show();
        });

        return tl;
    }

    public hideCountUp():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add(TweenLite.to(this._winCountUp, 0.2, {alpha: 0}));

        return tl;
    }

    public rescaleAndPosForWinCap():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            TweenLite.to(this._winCountUp, 0.2, {
                y: this._winCountUp.y - 20
            }),
            TweenLite.to(this._winCountUp.scale, 0.2, {
                y: 0.8,
                x: 0.8
            }),
        ]);
        return tl;
    }
}